import {PhrCategory} from './phr-category.model';

export class PatientPhr {
  id?: number;
  title: string;
  url: string;
  extension: string;
  patientId: number;
  categoryId?: number;
  category?: PhrCategory;
  tags?: number[];
  phrTags?: string[];
  description?: string;
  fromDate?: string;
  toDate?: string;
  date?: string;
}
